import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import formatPrice from '../../../helpers/formatPrice';
import 'react-loading-skeleton/dist/skeleton.css';

function CreditCardWithEntry() {
  const payments = useSelector((state) => state.payments);

  const { pathname } = window.location;
  const paths = pathname.split('/');
  const linktype = paths[3];

  const { totalDiscountPercentage, creditCardWithEntry, iepayment } = payments;

  const skeletonLoading = () => (
    <>
      <Skeleton height="25px" width="50%" />
      <Skeleton height="35px" width="50%" />
      <Skeleton height="25px" width="50%" />
      <Skeleton style={{ marginLeft: '50%' }} count={2} height="35px" width="50%" />
    </>
  );

  return (
    <td
      className={`d-block credit-card-info ${(totalDiscountPercentage > 0 || creditCardWithEntry.length === 0) ? '' : 'mt-4'}`}
    >
      {
        creditCardWithEntry.length === 0
          ? skeletonLoading()
          : (
            <>
              {
                totalDiscountPercentage > 0
                && (
                  <div className={(iepayment.cartaoEntradaDPType === 1) ? 'd-flex justify-content-between align-items-center' : 'mt-3 d-flex justify-content-between align-items-center'}>
                    <p className="blue mt-1">
                      Entrada fácil:
                    </p>
                    {iepayment.cartaoEntradaDPType === 1 && (
                      <p className="mt-1">
                        {'de '}
                        <span
                          className="text-decoration-line-through text-danger"
                        >
                          {`${formatPrice(creditCardWithEntry[0].totalAmountWithoutSR)}`}
                        </span>
                        {' por'}
                      </p>
                    )}
                    {iepayment.cartaoEntradaDPType === 2 && (
                      <p style={{ lineHeight: '21px', marginTop: '-3px' }} className="blue strong fs-large text-align-end mb-0">
                        {formatPrice(creditCardWithEntry[0].totalAmount)}
                        <span className="small"> (à vista)</span>
                      </p>
                    )}
                  </div>
                )
              }
              <div className={!(totalDiscountPercentage > 0) && 'd-flex justify-content-between align-items-center'}>
                {!(totalDiscountPercentage > 0) && (
                  <p className={`blue ${totalDiscountPercentage > 0 ? 'mt-1' : 'mt-3'}`}>
                    Entrada fácil:
                  </p>
                )}
                {iepayment.cartaoEntradaDPType === 1 && (
                  <p style={{ lineHeight: '20px' }} className="blue strong fs-large text-align-end mt-2 mb-0">
                    {formatPrice(creditCardWithEntry[0].totalAmount)}
                    <span className="small"> (à vista)</span>
                  </p>
                )}
              </div>
              <p
                style={{ borderBottom: '1px solid gray' }}
                className="text-align-end mb-1 pb-1"
              >
                {(linktype !== '2') && (
                <>
                  {formatPrice(
                    creditCardWithEntry[0].entryValue,
                    creditCardWithEntry[0].currency,
                  )}
                </>
                )}
              </p>

              <div className="d-flex justify-content-between align-items-start">
                <p className="mt-1">Cartão de Crédito:</p>
                <div style={{ width: '58%', lineHeight: '24px' }}>
                  {
                    totalDiscountPercentage > 0
                    && (
                      <p className="text-align-end payment mt-0">
                        <span className="small">{`de ${creditCardWithEntry[0].quantity}x `}</span>
                        <span className="text-decoration-line-through text-danger">{`${formatPrice(creditCardWithEntry[0].installmentAmountWithoutSR)}`}</span>
                        <span className="small">{' por'}</span>
                      </p>
                    )
                  }
                  {
                    creditCardWithEntry.map(({
                      quantity, installmentAmount,
                    }, index) => (
                      index === creditCardWithEntry.length - 1
                        ? (
                          <p key={installmentAmount} className="text-align-end my-1">
                            <span className="text-muted">{`${quantity}x `}</span>
                            <span className="strong">{formatPrice(installmentAmount)}</span>
                          </p>
                        )
                        : (
                          <p key={installmentAmount} className="text-align-end my-1">
                            <span className="text-muted">{`${quantity}x `}</span>
                            <span className="strong">{formatPrice(installmentAmount)}</span>
                            <span className="text-muted"> ou</span>
                          </p>
                        )
                    ))
                  }
                </div>
              </div>
            </>
          )
      }
    </td>
  );
}

export default CreditCardWithEntry;
